// Copyright (c) 2026 Solartek LLC. All rights reserved.

import { Skeleton } from '@/components/ui';
import { lazyPage } from '@/lib/lazy-page';

export const ProductivityPage = lazyPage(() => import('./productivity-page'));
export const ProductivityEmployeePage = lazyPage(() => import('./productivity-employee-page'));
export const MyProductivityPage = lazyPage(() => import('./my-productivity-page'));
export function PageFallback() { return <div className="page-container space-y-4"><Skeleton className="h-8 w-64" /><Skeleton className="h-64 w-full" /></div>; }
